import {Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {TtActivityEntry} from '../../interfaces/time-tracking/tt-activity-entry';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {TtActivityEntryFactory} from '../../factories/time-tracking/tt-activity-entry-factory';
import {DateTime, Interval} from 'luxon';
import {TimeHelper} from '../../helpers/time-helper';
import {TtProductEntry} from '../../interfaces/time-tracking/tt-product-entry';
import {TtProductEntriesTable} from './tt-product-entries.table';

@Injectable({
  providedIn: 'root'
})
export class TtActivityEntriesTable extends SyncTable<TtActivityEntry> {
  constructor(private ttProductEntriesTable: TtProductEntriesTable) {
    super(db.ttActivityEntries);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<TtActivityEntry>({
        api: ['tt-activity-entries'],
        fromObject: TtActivityEntryFactory.fromObject,
        toRemote: TtActivityEntryFactory.toRemote
      })
    };
  }

  /**
   *
   * @param opOperatingPlanItemId
   */
  public getByOpOperatingPlanItemId(opOperatingPlanItemId: number): Promise<TtActivityEntry[]> {
    return this.table.where('opOperatingPlanItemId').equals(opOperatingPlanItemId).toArray();
  }

  /**
   *
   */
  public override async getAll(): Promise<TtActivityEntry[]> {
    return this.table.orderBy('timeFrom').toArray();
  }

  /**
   *
   * @param date
   * @param dateTo
   */
  public async getByPeriod(date: DateTime | string | Date, dateTo: DateTime | string | Date = null): Promise<TtActivityEntry[]> {
    let ttActivityEntries = await this.getAll();
    date = TimeHelper.getDateString(date);

    return ttActivityEntries.filter(_ttActivityEntry => {
      if(date && !dateTo) {
        return _ttActivityEntry.timeFrom.substring(0, 10) === date;
      }
      else {
        dateTo = TimeHelper.getDateString(dateTo);
        return _ttActivityEntry.timeFrom.substring(0, 10) >= date && _ttActivityEntry.timeFrom.substring(0, 10) <= dateTo;
      }
    });
  }

  /**
   *
   * @param ttActivityEntry
   * @param ttProductEntries
   * @param isSynced
   */
  public async addWithTtProductEntries(
    ttActivityEntry: TtActivityEntry,
    ttProductEntries: TtProductEntry[],
    isSynced: boolean = false
  ): Promise<TtActivityEntry> {
    let addedTtActivityEntry: TtActivityEntry = null;

    db.transaction('rw', this.table, this.ttProductEntriesTable.table, async() => {
      addedTtActivityEntry = await super.add(ttActivityEntry, isSynced);
    });

    return addedTtActivityEntry;
  }

}
